import { instance } from '@/utils/http.js'


export const feedbackSaveApi = function (data) {
  return instance({
    url: "/api/v1/error/counter",
    method: 'post',
    data
  })
}